function StatsBox({ title = "Total Receivable (to collect)", text = "", className = "col-span-12 md:col-span-6" }) {
  return (
    <div className={` ${className}`}>
      <div className="bg-white p-4 rounded-lg shadow-md">
        <h3 className="font-semibold text-lg">{title}</h3>
        <p className="text-2xl font-bold" >&#8377; {parseInt(text, 10) || 0}</p>
      </div>
    </div>
  );
}
export default StatsBox;